import { MutationTree } from 'vuex';
import { State }        from '@/views/group-quotation-list/store/state.store';
import { GroupQuote }   from '@/views/group-quotation-list/group-quotation-list.types';

const mutations: MutationTree<State> = {
  setAllQuotes(state, quotes: GroupQuote[]): void {
    state.quotes = quotes;
  },
  setLoading(state, payload: boolean): void {
    state.loading = payload;
  },
};

export default mutations;
